export default __webpack_public_path__ + "static/media/icon-list.6c58328e.svg";